import React, { useEffect, useState } from 'react'
import { Box, Divider, Grid, IconButton, Tooltip } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import VehicleDetails from 'src/components/BuyPolicy/insuranceScreens/motor/VehicleDetails'
import ComprehensivePlan from 'src/components/BuyPolicy/insuranceScreens/motor/ComprehensivePlan'
import InsuranceCoverMenu from 'src/components/BuyPolicy/insuranceScreens/motor/InsuranceCoverMenu'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
import alert from 'src/assets/Buy_Policy_Images/Alert.svg'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import {
  getAddOnsList,
  getMotorInsuranceDetails,
} from 'src/services/buyPolicyMotorService'
import { useDispatch, useSelector } from 'react-redux'
import { getTokenForQrReport } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import { POLICY_TYPE_MOTOR } from 'src/utils/constants/BuyPolicyMotor'
import BackArrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { useHistory } from 'react-router-dom'
import {
  showNotificationMessage,
  updateMotorDetails,
  updatePACoverArray,
} from 'src/actions'
import EmptyInsuranceDetails from 'src/components/BuyPolicy/common/EmptyInsuranceDetails'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import {
  ERROR_FETCHING_LIST,
  NO_ADD_ONS_AVALIABLE,
  YES,
} from 'src/utils/constants/BuyPolicy'

const MotorInsuranceDetails = () => {
  const classes = useStyles()
  // eslint-disable-next-line
  const [sortBy, setSortBy] = useState('')
  const history = useHistory()
  const dispatch = useDispatch()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const paCoverDetails = useSelector((state) => state?.paCoverAmountReducer)
  const [addOnsList, setAddOnsList] = useState([])
  const [motorQuote, setMotorQuote] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingQuote, setLoadingQuote] = useState(false)

  // const handleChangeSortBy = (event) => {
  //   setSortBy(event.target.value)
  // }

  const expiryAlert = false
  const payAsYouDrive = false
  const handleBack = (event) => {
    event?.preventDefault()
    history.push('/individual/dashboard/buyPolicy/motor')
  }
  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      fetchMotorInsuranceDetails(token)
      fetchAddOnsList(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchMotorInsuranceDetails = async (token) => {
    setLoadingQuote(true)
    const formData = {
      userName: motorDetails?.personalDetails?.name,
      mobile: motorDetails?.personalDetails?.mobileNumber,
      email: motorDetails?.personalDetails?.email,
      city: motorDetails?.personalDetails?.city,
      state: motorDetails?.personalDetails?.state,
      pinCode: motorDetails?.personalDetails?.pincode,
      makeId: motorDetails.vehicleDetails?.brand?.genericName,
      modelId: motorDetails?.vehicleDetails?.model?.id,
      variantId: motorDetails?.vehicleDetails?.variant?.id || '',
      fuelTypeId: motorDetails?.vehicleDetails?.fuelType?.id,
      registrationDate: motorDetails?.vehicleDetails?.regDate,
      vehicleNumber: motorDetails?.vehicleDetails?.vehicleNumber,
      previousInsuranceProvider:
        motorDetails?.previousPolicyDetails?.previousPolicyProvider
          ?.insuranceCompanyFirstName,
      previousPolicyNumber:
        motorDetails?.previousPolicyDetails?.previousPolicyNumber,
      claimsOnPreviousPolicy:
        motorDetails?.previousPolicyDetails?.existingPolicyClaim === YES,
      previousPolicyExpiryDate: motorDetails?.previousPolicyDetails?.expiryDate
        ? motorDetails?.previousPolicyDetails?.expiryDate
        : motorDetails?.previousPolicyDetails?.expiredDate,
      isVehicleRegisteredUnderCompanyName:
        motorDetails?.vehicleDetails?.isCompany,
      companyName: motorDetails?.vehicleDetails?.companyName,
      policyBusinessType: motorDetails?.currentPolicyDetails?.policyType,
      isPA: motorDetails?.currentPolicyDetails?.paCover,
      payAsYouDrive: false,
      insuredNoOfKms: null,
      previousNCB: motorDetails?.previousPolicyDetails.ncb,
      addOns: motorDetails?.currentPolicyDetails?.addOns,
      thirdPartyPolicyExpiryDate:
        motorDetails?.previousPolicyDetails?.thirdPartyExpiryDate || '',
      thirdPartyProvider:
        motorDetails?.previousPolicyDetails?.thirdPartyProviderFirstName || '',
      thirdPartyPolicyNo:
        motorDetails?.previousPolicyDetails?.thirdPartyPolicyNo || '',
      thirdPartyStartDate:
        motorDetails?.previousPolicyDetails?.thirdPartyStartDate || '',
      vehicleSearchQuery: motorDetails?.vehicleDetails?.model?.modelGenericName,
      manufacturingMonth: motorDetails.vehicleDetails?.monthOfManufacturer,
      manufacturingYear: motorDetails.vehicleDetails?.yearOfManufacturer,
      engineNo: motorDetails.vehicleDetails?.engineNumber,
      chassisNo: motorDetails.vehicleDetails?.chassisNumber,
      idv: motorDetails?.currentPolicyDetails?.idv,
    }
    const response = await getMotorInsuranceDetails(token, formData)
    try {
      if (response?.res?.status !== 200) {
        setLoadingQuote(false)

        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoadingQuote(false)
      const responseData = response?.res?.data
      if (responseData?.success) {
        setMotorQuote(responseData?.quickQuoteResponse)
        if (!motorDetails?.previousPolicyDetails?.previousProviderLogo) {
          dispatch(
            updateMotorDetails({
              previousPolicyDetails: {
                ...motorDetails?.previousPolicyDetails,
                previousProviderLogo: responseData?.previousProviderImage,
              },
              currentPolicyDetails: {
                ...motorDetails?.currentPolicyDetails,
                idvMinValue: responseData?.minIdv,
                idvMaxValue: responseData?.maxIdv,
              },
            })
          )
        }

        if (!paCoverDetails?.paCoverValues) {
          const paAmountObject = createPaProviderObject(
            responseData?.quickQuoteResponse
          )
          dispatch(updatePACoverArray(paAmountObject))
        }
      } else {
        setMotorQuote(responseData?.quickQuoteResponse)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoadingQuote(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }
  const fetchAddOnsList = async (token) => {
    setLoading(true)

    const response = await getAddOnsList(token)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setAddOnsList(responseData)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NO_ADD_ONS_AVALIABLE,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_FETCHING_LIST,
        })
      )
    }
  }

  const createPaProviderObject = (data) => {
    const result = {}

    for (const entry of data) {
      const providerId = entry?.providerId
      const paPremium = entry?.paPremium
      const type = 'PA_COVER'

      if (paPremium !== null) {
        result[providerId] = {
          paPremium: paPremium,
          type: type,
        }
      }
    }
    return result
  }

  useEffect(() => {
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [motorDetails])

  return (
    <>
      <LoadingModal loading={loading || loadingQuote} />
      <Box className={classes.componentBackground}>
        <Box className={classes.componentElement}>
          <Box className={classes.insuranceDetailsMain}>
            <Grid container spacing={2} direction='column'>
              <Grid item xs={12}>
                <VehicleDetails isEdit={true} />
              </Grid>
              <Box>
                <Box className={classes.containerBack}>
                  <IconButton onClick={handleBack}>
                    <img src={BackArrow} alt='back-arrow-img' />
                  </IconButton>

                  <Box className={classes.containerBackText}>Go back</Box>
                </Box>
              </Box>
              <Grid item container direction='row' spacing={4}>
                <Grid item xs={12} md={3.5}>
                  <InsuranceCoverMenu addOnsList={addOnsList} />
                </Grid>
                <Grid item xs={12} md={8.5}>
                  <Box className={classes.GridTwoSectionTwoContainerMain}>
                    <Box className={classes.GridTwoSectionTwoContainerOne}>
                      <Box>
                        <span
                          className={
                            classes.GridTwoSectionTwoContainerOneTextOne
                          }
                        >
                          {`${motorQuote?.length} ${
                            POLICY_TYPE_MOTOR[
                              motorDetails?.currentPolicyDetails?.policyType
                            ]
                          } `}
                          Plans
                        </span>
                        {payAsYouDrive && (
                          <span
                            className={
                              classes.GridTwoSectionTwoContainerOneTextTwo
                            }
                          >
                            along with 2 Pay as you Drive Plans
                          </span>
                        )}
                        {payAsYouDrive && (
                          <span className={classes.cardCommonColor}>
                            <Tooltip
                              title={
                                <>
                                  <Box>Pay as you drive</Box>
                                </>
                              }
                            >
                              <img
                                src={infoToolTip}
                                alt={infoToolTip}
                                className={classes.infoImage}
                              />
                            </Tooltip>
                          </span>
                        )}
                      </Box>
                      <Box>
                        {/* <FormControl*/}
                        {/*  size='small'*/}
                        {/*  className={classes.GridTwoSectionTwoContainerOneSelect}*/}
                        {/* >*/}
                        {/*  <InputLabel id='sortByLabel'>Sort by</InputLabel>*/}
                        {/*  <Select*/}
                        {/*    labelId='sortBySelect'*/}
                        {/*    id='sortBySelect'*/}
                        {/*    value={sortBy}*/}
                        {/*    label='Sort by'*/}
                        {/*    onChange={handleChangeSortBy}*/}
                        {/*    className={classes.selectRadius}*/}
                        {/*  >*/}
                        {/*    <MenuItem value={'latest'}>Latest</MenuItem>*/}
                        {/*    <MenuItem value={'popular'}>Popular</MenuItem>*/}
                        {/*  </Select>*/}
                        {/* </FormControl> future dev could be there*/}
                      </Box>
                    </Box>
                    <Box className={classes.comprehensiveContainer}>
                      {motorQuote?.length !== 0 ? (
                        <Box>
                          {motorQuote?.map((item) => {
                            return (
                              <ComprehensivePlan
                                quote={item}
                                length={motorQuote?.length}
                                logo={item?.providerImage}
                                idvCover={item?.idvCover}
                                price={item?.grossTotalPremium}
                                recommend={true}
                                key={item?.providerId}
                                paCover={
                                  motorDetails?.currentPolicyDetails?.paCover
                                }
                                policyType={
                                  motorDetails?.currentPolicyDetails?.policyType
                                }
                              />
                            )
                          })}
                        </Box>
                      ) : (
                        <Box>
                          {!loadingQuote && !loading ? (
                            <EmptyInsuranceDetails />
                          ) : null}
                        </Box>
                      )}
                    </Box>
                    {expiryAlert && (
                      <Box>
                        <Box className={classes.alertContaniner}>
                          <img src={alert} alt='alert' />
                          <Box className={classes.alertContent}>
                            Policy Expiry Alert: Less than 31 hours left! Renew
                            now to avoid price increases and potential car
                            inspection.
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                  {payAsYouDrive && (
                    <Box className={classes.overallContainer}>
                      <Box className={classes.dividerContainer}>
                        <Box className={classes.dividerAction}>
                          <Divider className={classes.dividerActionOne}>
                            Pay as you drive Plans
                          </Divider>
                        </Box>
                        <Box className={classes.dividerActionText}>
                          <Box clasaName={classes.downArrowContent}>
                            <KeyboardDoubleArrowDownIcon
                              className={classes.downArrow}
                            />
                          </Box>
                          <Box className={classes.dividerText}>
                            Pay as you drive suits you if you drive less than
                            5000 km or if you have more than one car that you
                            use sparingly.
                          </Box>
                        </Box>
                        <Box className={classes.dividerAction}>
                          <Divider className={classes.dividerActions} />
                        </Box>
                      </Box>
                      <Box className={classes.detailsContainer}></Box>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default MotorInsuranceDetails

const useStyles = makeStyles({
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 1vw',
  },
  cardMain: {
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    gap: 15,
  },
  cardOne: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardTwo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    gap: 10,
  },

  cardTextOne: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#9D9D9D',
  },
  cardTextTwo: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  cardTextThree: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '15px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  insuranceDetailsMain: {
    padding: '20px 20px 20px 20px',
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
  },
  GridOne: {
    border: '1px solid #BED2D8',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'row',
    background: 'linear-gradient(271.38deg, #4DC3E3 -239.49%, #FFFFFF 51.17%)',
    gap: 30,
    flexWrap: 'wrap',
  },
  GridOneSectionHeading: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#939393',
  },
  GridOneSectionData: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19px',
    letterSpacing: '0em',
  },
  BtnEdit: {
    border: '1px solid #E4E4E4',
    width: 60,
    height: 27,
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '14.06px',
    color: '#2BACCF',
  },
  sectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    padding: 10,
  },
  sectionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  editIcon: {
    color: '#2BACCF',
  },
  GridTwoSectionTwoContainerMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingTop: '4vh',
  },
  GridTwoSectionTwoContainerOne: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  GridTwoSectionTwoContainerOneSelect: {
    width: '100px',
  },
  cardCommonColor: {
    color: '#2BA8CA',
  },
  GridTwoSectionTwoContainerOneTextOne: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '21px',
    letterSpacing: '0em',
    color: '#3C3C3C',
  },
  GridTwoSectionTwoContainerOneTextTwo: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '21px',
    letterSpacing: '0em',
    color: '#2BA8CA',
    marginRight: '0.4vw',
  },
  GridTwoSectionTwoContainerOneInfoIcon: {},
  overallContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: '3vh',
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    flexWrap: 'wrap',
  },
  dividerAction: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 600,
    color: '#3AA1BD',
    textTransform: 'uppercase',
  },
  dividerActionOne: {
    '&::before, &::after': {
      borderColor: '#4DC3E3 !important',
    },
  },
  dividerActions: {
    variant: 'middle',
    borderColor: '#4DC3E3 !important',
  },
  dividerText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    textAlign: 'center',
    paddingBottom: '3px',
  },
  dividerActionText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
  },
  downArrow: {
    color: '#4DC3E3',
  },
  alertContaniner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    border:
      '1px solid linear-gradient(90.04deg, #FFA58D 7.29%, #FE6488 86.69%)',
    background: '#FFE7E7',
    borderRadius: '10px',
    padding: '1%',
    margin: '10px 0px',
  },
  alertContent: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'italic',
    fontWeight: 400,
    color: '#844655',
    paddingLeft: '4px',
  },
  selectRadius: {
    borderRadius: '3px',
  },
  modalRoot: {
    borderRadius: '10px',
    borderRightWidth: '5px',
    borderBottomWidth: '10px',
  },
  modalContent: {
    textAlign: 'center',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
    borderRadius: '10px',
    borderTop: '1px solid #EF669B',
    borderLeft: '1px solid #EF669B',
    borderRight: '5px solid #EF669B',
    borderBottom: '5px solid #EF669B',
  },

  infoImage: {
    marginBottom: '-5px',
    width: '20px',
    paddingLeft: '10px',
  },
  comprehensiveContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    flexWrap: 'wrap',
  },
  componentElement: {
    maxWidth: '1240px !important',
    width: '100%',
  },
  componentBackground: {
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: '100% 40%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
  },
  containerBack: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    padding: '10px 0px 0px 10px',
  },
  containerBackText: {
    fontFamily: 'Roboto',
    fontSize: '0.8125em',
    fontWeight: 400,
    lineHeight: '0.9375em',
    letterSpacing: '0em',
    color: '#3E3E3E',
  },
})
